<template>
  <div class="overflow-auto">
    <b-row>
      <b-col sm="4">
        <b-input type="text" placeholder="Type to search" v-model.trim="filter"></b-input>
      </b-col>
      <b-col sm="4">
        <b-form-select :plain="true" :options="levelOptions" v-model="selectedLevel" text-field="Name" value-field="Value">
          <template slot="first">
            <option :value="null">-- Please select an option --</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
    <br>
    <div class="overflow-auto">
      <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="getMemberRecords" :fields="getFields" :filter="filter" class="riskAnalysisUserDuplicateData">
        <template v-slot:cell(Deposit)="data">
          {{ format(data.item.Deposit, '0,0.00') }}
        </template>
        <template v-slot:cell(Withdraw)="data">
          {{ format(data.item.Withdraw, '0,0.00') }}
        </template>
        <template v-slot:cell(Promotion)="data">
          {{ format(data.item.Promotion, '0,0.00') }}
        </template>
        <template v-slot:cell(Turnover)="data">
          {{ format(data.item.Turnover, '0,0.00') }}
        </template>
        <template v-slot:cell(Netwin)="data">
          {{ format(data.item.Netwin, '0,0.00') }}
        </template>
        <template v-slot:cell(Status)="data">
          <b-badge variant="success" v-if="data.item.Status === 0">Active</b-badge>
          <b-badge variant="danger" v-else-if="data.item.Status === 1">Disable</b-badge>
          <b-badge variant="warning" v-else-if="data.item.Status === 2">Frozen</b-badge>
        </template>
        <template v-slot:cell(Level)="data">
          <b-badge v-if="data.item.Level === 1" variant="danger">Level 1</b-badge>
          <b-badge  v-if="data.item.Level === 2" variant="warning">Level 2</b-badge>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
export default {
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    records: {
      type: Array,
      default: function () { return [] }
    },
    reportType: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      filter: '',
      selectedLevel: null,
      levelOptions: [
        { Value: 1, Name: 'Level 1' },
        { Value: 2, Name: 'Level 2' }
      ]
    }
  },
  computed: {
    getMemberRecords: function () {
      if (this.selectedLevel !== null) {
        return this.records.filter(x => x.Level === this.selectedLevel)
      } else {
        return this.records
      }
    },
    getFields: function () {
      const fieldData = [
        {key: 'Level', label: 'Operate'},
        {key: 'Username', label: 'Username'},
        {key: 'MachineNo', label: 'MachineNo'},
        {key: 'AddIP', label: 'IP'},
        {key: 'BankBranch', label: 'BankBranch'},
        {key: 'Deposit', label: 'Deposit'},
        {key: 'Withdraw', label: 'Withdraw'},
        {key: 'Netwin', label: 'Netwin'},
        {key: 'Promotion', label: 'Promotion'},
        {key: 'Turnover', label: 'Turnover'},
        {key: 'Status', label: 'Status'},
        {key: 'LastModifyDate', label: 'Detected Date'}
      ]
      if (this.reportType === 'signup') {
        return fieldData
      } else {
        return [...fieldData, {key: 'FirstDepositAmount', label: 'First Deposit Amount'}, {key: 'FirstDepositTime', label: 'First Deposit Time'}]
      }
    }
  },
  methods: {
    format (val, format) {
      return numeral(val).format(format)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report/risk/ReportDetail.vue